import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {OddsPreviewApiModel} from "./odds-preview.api-model";
import {OddsCellDomainModel} from "./odds-cell/odds-cell.domain-model";
import {makeObservable, observable} from 'mobx';


export class OddsPreviewDomainModel extends BaseDomainModel {
  @observable cells: Array<OddsCellDomainModel>;

  constructor(model: OddsPreviewApiModel) {
    super(model);

    this.cells = model?.cells?.map((cell) => new OddsCellDomainModel(cell));
    makeObservable(this);
  }

  update(model: OddsPreviewDomainModel) {
    super.update(model);

    if(model) {
      this.cells = model.cells;
    }
  }
}
